//make sure you update the back end pricing discount too! in /app/Services/AgentAccountService.php
export default {
    "LH" : [
        {
            "startDate" : '2023-06-22',
            "endDate" : '2023-08-15 22:30:00',
            'discount_percentage_off' : .10
        }
    ]
};